
export enum Gateway {
  Stripe = 'stripe',
  PayZen = 'payzen',
  PagSeguro = 'pagseguro',
  Getnet= 'getnet',
}
